export enum ChartColors {
  blue = "#0055ff",
  blueLight = "#80aaff",
  red = "#bf4040",
  redLight = "#df9f9f",
  orange = "#ffbf00",
  yellow = "#F9C80E",
  green = "#13D8AA"
}
